export const fakeReviews = [
  {
    id: "01H3SKM8KC8F6QJF5V77NQWFBT",
    name: "Wyn Abotson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review: "thats great",
    img: "https://i.pravatar.cc/300",
  },
  {
    id: "0MY1H3R4MRVQ4162GEXQ4TTDKW",
    name: "Wyn Abotson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review: "that great",
    img: "https://i.pravatar.cc/300",
  },
  {
    id: "01H3Q44MRRVQ4162GEXTTMYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3RMRTTVQ4162GEXQ44MYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3Q44MRRVQ4162GEXTTMYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3RMRTTVQ4162GEXQ44MYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3Q44MRRVQ4162GEXTTMYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3RMRTTVQ4162GEXQ44MYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3Q44MRRVQ4162GEXTTMYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3RMRTTVQ4162GEXQ44MYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3Q44MRRVQ4162GEXTTMYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3RMRTTVQ4162GEXQ44MYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3Q44MRRVQ4162GEXTTMYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3RMRTTVQ4162GEXQ44MYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3Q44MRRVQ4162GEXTTMYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
  {
    id: "01H3RMRTTVQ4162GEXQ44MYDKW",
    name: "fafasfa Abofasfatson",
    email: "wabotson0@earthlink.net",
    rating: 4,

    review:
      "that great, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the serviceat, i am happy with the service",
    img: "",
  },
];
